// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3dVwu","range":"MonthRangeSwitch_range__MP9To","disabled":"MonthRangeSwitch_disabled__2paDl"};